import type { InjectionKey, Ref } from "vue";

interface MoreMenuProvide {
  // id of the submenu whose flyout is open, at most one at a time
  activeId: Readonly<Ref<string | null>>;
  // opens the flyout (or closes it with null) right away
  select: (id: string | null) => void;
  // the pointer entered this flyout's row or flyout (null: a row without one)
  hover: (event: PointerEvent, id: string | null) => void;
  // the pointer left the More list or a flyout
  leave: (event: PointerEvent) => void;
  close: () => void;
  // submenu flyouts teleport here: inside the action menu (so clicks don't deactivate the sticky)
  // but outside the More popup, whose overflow would clip them
  host: Ref<HTMLElement | null>;
}

export const moreMenuKey: InjectionKey<MoreMenuProvide> = Symbol("moreMenu");
